import { API } from '@/lib/api';

function getResearchDraftStorageKey(workspaceId) {
  return `agent_workspace_research_draft_${workspaceId}`;
}

export async function ensureAgentWorkspace({ headers, payload }) {
  const resp = await fetch(`${API}/agent-workspaces/ensure`, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  if (!resp.ok) {
    throw new Error('Failed to ensure workspace');
  }
  return resp.json();
}

export async function fetchAgentWorkspace({ workspaceId, headers }) {
  const resp = await fetch(`${API}/agent-workspaces/${workspaceId}`, {
    headers,
    credentials: 'include',
  });
  if (!resp.ok) {
    throw new Error('Failed to load workspace');
  }
  return resp.json();
}

export async function updateResearchWorkspaceState({ workspaceId, headers, payload }) {
  const resp = await fetch(`${API}/agent-workspaces/${workspaceId}/research-state`, {
    method: 'PUT',
    headers,
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  if (!resp.ok) {
    throw new Error('Failed to update research workspace state');
  }
  return resp.json();
}

export function saveResearchWorkspaceDraft(workspaceId, draft) {
  if (!workspaceId || typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(
      getResearchDraftStorageKey(workspaceId),
      JSON.stringify({
        ...draft,
        saved_at: new Date().toISOString(),
      }),
    );
  } catch {}
}

export function loadResearchWorkspaceDraft(workspaceId) {
  if (!workspaceId || typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(getResearchDraftStorageKey(workspaceId));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearResearchWorkspaceDraft(workspaceId) {
  if (!workspaceId || typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(getResearchDraftStorageKey(workspaceId));
  } catch {}
}
